import React from 'react';
import { Box, Button, styled, Typography } from '@mui/material';
import VoiceCircle from '../../components/conversations/VoiceCircle';

const Page = styled(Box)`
  background-color: '#E3E5E8';
`;

const GradientOverlay = styled(Box)`
  background: radial-gradient(circle, 
    #FFF2E7 0%, 
    #F9F8F8 34%, 
    #FFFFFF 71%, 
    #E6ECF8 100%
  );

  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
`;

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  max-width: 25rem;
  align-items: center;
  height: 100vh;
  text-align: center;
`;

const Header = styled('header')`
  margin-bottom: 2rem;
  margin-top: 10rem;
`;

type SplashScreenProps = {
  onStart: () => Promise<void>;
};

export const SplashScreen = ({ onStart }: SplashScreenProps) => {
  const handleClick = () => {
    onStart(); 
  };

  return (
    <>
      <Header>
        <Typography variant="h5" fontWeight="normal">Let's Have a Short Conversation</Typography>
        <Typography variant="body1" marginTop="1rem">
          Please let us help you to get familiar with our AI chat system. We are going to ask you
          few question and feel free to answer them by talking through your microphone.
        </Typography>
      </Header>
      
        <Button
          variant="contained"
          color="primary"
          type="submit"
          onClick={handleClick}
        >
          Start the Conversation
        </Button>
      
    </>
  );
};
